import { useCallback, useContext } from 'react';
import ModalContext from '~/contexts/ModalContext';
import { useTrackEvent } from '~/contexts/SearchAnalyticsContext';

export enum SoftPullLocations {
  Conditional = 'Conditional Tile',
  PriceAndPayment = 'Price and Payment',
  ToolTip = 'Estimate Tool Tip',
  Unlock = 'Unlock Payment CTA',
  Modal = 'More Details Modal CTA'
}
export function useOpenSoftPullModal(location: SoftPullLocations) {
  const { setSoftPullModalOpen } = useContext(ModalContext);
  const trackEvent = useTrackEvent();

  return useCallback(() => {
    setSoftPullModalOpen(true);
    trackEvent('MerchUI Opened Soft Pull Modal', {
      openLocation: location
    });
  }, [location, setSoftPullModalOpen, trackEvent]);
}
